import React, { useContext } from 'react';
import { MediaContext, NavigationContext } from './context';
import ImageWithShimmer from '../common/ImageWithShimmer';
import { IMAGE_COMPRESSOR } from '../../utils/imageCompressor';
import getSpinThumbnail from '../../utils/getSpinThumbnail';
import { playIcon, videoThumbnail } from '../common/config';
import icon360 from '../Svgs/360_logo.svg';
import icon3d from '../Svgs/3d_icon.svg';

const GridItem = ({ item, index, template, rightGrid=false, isMobile = false }) => {
    const { selectedIndex, handleSelectThumbnail } = useContext(NavigationContext);
    const { aspectRatio } = useContext(MediaContext);
    const spinThumbnail = () => {
        if (item.type === "360") {
            return getSpinThumbnail({ images: item?.data?.skuDetails, firstAngle: item?.data?.sequenceData?.first_frame_angle || null });
        }
        return null;
    }
// const [isHover, setIsHover] = useState(false);

    return (
        <div key={index} className={`${rightGrid ? "" : "h-full flex-none"} relative hover:scale-105 transition-all duration-300`}
            style={{
                scrollSnapAlign: 'center', // Make items snap to center
                aspectRatio: aspectRatio
            }}
            onClick={(e) => {e.isTrusted && handleSelectThumbnail(index, item.type)}}
            // onMouseEnter={() => setIsHover(true)}
            // onMouseLeave={() => setIsHover(false)}

        >
            {
                item.type === "image" && <div className={`w-full h-full relative border overflow-hidden rounded-lg ${selectedIndex === index ? "border-2 border-black-carbon" : ""} `}
                >
                    <ImageWithShimmer src={IMAGE_COMPRESSOR({ url: item?.data?.output_image_hres_url, resolution: (typeof aspectRatio !== 'undefined' && aspectRatio === '16/9') ? '375x' : '375x' })} alt={item?.data?.alt || 'image'} className={`w-full h-full object-contain cursor-pointer`} />
                </div>
            }
            {
                item.type === "video" && <div className={`w-full h-full relative rounded-lg border overflow-hidden  ${selectedIndex === index ? "border-2 border-black-carbon" : ""}`}>
                    <ImageWithShimmer src={IMAGE_COMPRESSOR({ url: videoThumbnail, resolution: aspectRatio === '16/9' ? '375x' : '375x' })} alt={item?.data?.alt || 'video'} className={`w-full h-full object-contain object-center cursor-pointer`} />
                    <div className='absolute z-[11] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center'>
                        <img
                            src={playIcon}
                            alt="Overlay"
                            className={`w-[30px] h-[30px] z-[11] ${template === "t2" ? "lg:w-[40px] lg:h-[40px]" : ""}`}
                        />
                        <p className={` text-white-70 mt-1 text-[10px] leading-[10px] lg:text-xs text-center font-medium whitespace-nowrap ${template === "t2" ? "lg:text-sm" : ""}`}>Featured Video</p>
                    </div>
                </div>
            }
            {
                item.type === "360" && <div className={`w-full h-full relative rounded-lg border  overflow-hidden  ${selectedIndex === index ? "border-2 border-black-carbon" : ""}`}>
                    <ImageWithShimmer src={IMAGE_COMPRESSOR({ url: spinThumbnail()?.output_image_hres_url, resolution: aspectRatio === '16/9' ? '375x' : '375x' })} alt={item?.data?.alt || '360'} className={`w-full h-full object-contain cursor-pointer`} />
                    <div className="absolute top-1 right-1 z-[12] pointer-events-none">
                        <img src={icon360} alt="360 view" className="w-9 h-9" />
                    </div>
                </div>
            }
            {
                item.type === "360Int" && <div className={`w-full h-full relative rounded-lg border  overflow-hidden  ${selectedIndex === index ? "border-2 border-black-carbon" : ""}`}>
                    <ImageWithShimmer src={IMAGE_COMPRESSOR({ url: item?.data?.[0]?.output_image_hres_url, resolution: aspectRatio === '16/9' ? '375x' : '375x' })} alt={item?.data?.[0]?.alt || '360Int'} className={`w-full h-full object-contain cursor-pointer`} />
                    <div className="absolute top-1 right-1 z-[12] pointer-events-none">
                        <img src={icon360} alt="360 view" className="w-9 h-9" />
                    </div>
                </div>
            }
            {
                item.type === "threed" && (
                  <div className={`w-full h-full relative rounded-lg border overflow-hidden ${selectedIndex === index ? "border-2 border-black-carbon" : ""}`}>
                    {item?.data?.thumbnail_url ? (
                      <>
                        <ImageWithShimmer
                          src={IMAGE_COMPRESSOR({ url: item?.data?.thumbnail_url, resolution: aspectRatio === '16/9' ? '375x' : '375x' })}
                          alt={item?.data?.alt || '3d'}
                          className="w-full h-full object-conver cursor-pointer"
                        />
                        <div className="absolute top-1 right-1 z-[12] pointer-events-none w-10 h-10 flex items-center justify-center rounded-xl shadow-lg bg-[#2D2D2F]/70">
                          <img src={icon3d} alt="3d view" className="w-6 h-6" />
                        </div>
                      </>
                    ) : (
                      <div className="w-full h-full flex flex-col items-center justify-center bg-black-80">
                        <div className="w-10 h-10 rounded-full bg-white-default flex items-center justify-center">
                          <img src={icon3d} alt="3d view" className="w-6 h-6" />
                        </div>
                        <p className="mt-1 text-[10px] leading-[10px] text-white-70 font-medium whitespace-nowrap">3D View</p>
                      </div>
                    )}
                  </div>
                )
            }
        </div>
    )
}

export default GridItem;